if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      // IBO 2026-09-29
      window.removeEventListener('scroll', this.iboQueue);
      window.removeEventListener('resize', this.iboQueue);
      // /IBO
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // IBO 2026-09-29: phones are handled by iboCheck() below (was: toggle --out while the form's bottom > 0,
          // so the bar only appeared after the form had scrolled above the screen and never while it was still below it).
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.iboCheck();
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);

      // IBO 2026-09-29: phones (< md): the bar shows whenever the main Add to cart button is not fully on screen:
      // below the screen (short in-app browsers), or scrolled up behind the sticky header (--header-end) or above it.
      // It hides only while the button itself is fully visible, so there is no moment with neither on screen.
      this.iboRaf = 0;
      this.iboQueue = () => {
        if (this.iboRaf) return;
        this.iboRaf = requestAnimationFrame(() => { this.iboRaf = 0; this.iboCheck(); });
      };
      window.addEventListener('scroll', this.iboQueue, { passive: true });
      window.addEventListener('resize', this.iboQueue);
      this.iboCheck();
      setTimeout(() => this.iboCheck(), 300); // after the header has set --header-end
      // /IBO
    }

    // IBO 2026-09-29: see bindEvents()
    iboCheck() {
      // IBO 2026-09-29 (Instacart-structure spec): phones show the bar from the first paint (render-blocking rules in
      // assets/ibo.css, inline Add to cart hidden), so there is nothing to toggle below md any more.
      if (!theme.mediaMatches.md) { this.classList.remove('sticky-atc-panel--out'); return; }
      // /IBO
      if (theme.mediaMatches.md || !this.productForm) return;
      const btn = this.productForm.querySelector('[name="add"]');
      if (!btn) return;
      const r = btn.getBoundingClientRect();
      if (!r.height) return;
      const headerEnd = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-end')) || 0;
      const top = Math.max(0, Math.min(headerEnd, window.innerHeight / 2));
      const inView = r.top >= top && r.bottom <= window.innerHeight;
      this.classList.toggle('sticky-atc-panel--out', inView);
    }
    // /IBO

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
